import { TheWestSection } from '@news-mono/component-library'
import { StaticRoutes } from '@news-mono/web-common'
import { getBlakDeathsInCustodyRouteInfo } from './features/blak-deaths-in-custody'
import { getGenesisRouteInfo } from './features/genesis-ballet'
import { getLisaGovanRouteInfo } from './features/lisa-govan'
import { getWestTonightRouteInfo } from './features/the-west-tonight'
import { getUpLateRouteInfo } from './features/up-late'
import { getYourStoryOurStoryRouteInfo } from './features/your-story-our-story'
import { homepage } from './home'
import { getNewsletterSubscriptionRouteInfo } from './newsletter-subscription/newsletter-subscription'
import { puzzles } from './puzzles'
import { regionalRoutes } from './regionals'
import { staticContentRoutes } from './static/static-content-routes'
import { customTopicRoutes } from './topic/custom-topic-routes'
import { liveScoresRoute } from './topic/custom/get-live-scores-route-info'
import { upgradeAppRoute } from './upgrade-app-route-info'
import { westlive } from './west-live'

export const staticRoutes: StaticRoutes<TheWestSection> = {
    ...puzzles,
    ...staticContentRoutes,
    ...customTopicRoutes,
    ...homepage,
    ...regionalRoutes,
    ...westlive,
    ...getYourStoryOurStoryRouteInfo,
    ...getLisaGovanRouteInfo,
    ...getNewsletterSubscriptionRouteInfo,
    ...getBlakDeathsInCustodyRouteInfo,
    ...getGenesisRouteInfo,
    ...upgradeAppRoute,
    ...getWestTonightRouteInfo,
    ...getUpLateRouteInfo,
    ...liveScoresRoute,
}
